import { render, staticRenderFns } from "./teacherLibrary.vue?vue&type=template&id=5aa610b5&scoped=true&"
import script from "./teacherLibrary.vue?vue&type=script&lang=js&"
export * from "./teacherLibrary.vue?vue&type=script&lang=js&"
import style0 from "./teacherLibrary.vue?vue&type=style&index=0&id=5aa610b5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa610b5",
  null
  
)

export default component.exports